import React, { useState } from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import { electionVoteConfirm } from "./ElectionVoteConfirmable";
import axios from "axios";
import classnames from "classnames";
import { DOWNVOTE, UPVOTE } from "./constants/vote-types";
import { ElectionResource } from "./proptypes/election-resource";
import { VoteResource } from "./proptypes/vote-resource";

const btnNames = {
    [UPVOTE]: "Upvote",
    [DOWNVOTE]: "Downvote",
};

const ElectionVoteForm = (props) => {
    const {
        vote,
        election,
        canVote,
    } = props;
    const [isLoading, setLoading] = useState(false);

    const onVote = async () => {
        const { type, reason } = await electionVoteConfirm({ user: election?.candidate });
        try {
            setLoading(true)
            await axios.post(`/election/${election.id}/vote`, { type, reason });
            window.location.reload();
        } finally {
            setLoading(false);
        }

        return election;
    };

    return (
        <div>
            <button
                disabled={isLoading || !canVote}
                className={classnames("w-100 btn", {
                    "btn-success": vote?.type === UPVOTE,
                    "btn-danger": vote?.type === DOWNVOTE,
                    "btn-warning": !vote?.type,
                })}
                onClick={onVote}
            >
                {vote?.type ? btnNames[vote?.type] : "Vote"}
            </button>
        </div>
    );
};

ElectionVoteForm.propTypes = {
    election: PropTypes.shape(ElectionResource),
    vote: PropTypes.shape(VoteResource),
    canVote: PropTypes.bool,
};

ElectionVoteForm.defaultProps = {
    election: null,
    vote: null,
};

const vote = JSON.parse(document.currentScript.dataset.vote || null);
const election = JSON.parse(document.currentScript.dataset.election || null);
const canVote = JSON.parse(document.currentScript.dataset.canVote || false);
const node = document.getElementById('react-election-vote-form');
render(<ElectionVoteForm vote={vote} election={election} canVote={canVote} />, node);
